import { createSlice } from "@reduxjs/toolkit";
import { getMaintenanceDataAction, scheduleMaintenanceAction } from "./actions";
import { initialState } from "./initialState";
import { MaintenanceTypes } from "./maintenanceTypes";
import { maintenanceReducer } from "./reducer";

export const maintenanceSlice = createSlice({
  name: "maintenance",
  reducers: maintenanceReducer,
  initialState,
  extraReducers: {
    [getMaintenanceDataAction.pending.toString()]: (
      state: MaintenanceTypes
    ) => ({
      ...state,
    }),
    [getMaintenanceDataAction.fulfilled.toString()]: (
      state: MaintenanceTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        isMaintenance: result?.under_maintenance,
        maintenanceData: result,
        success,
      };
    },
    [getMaintenanceDataAction.rejected.toString()]: (
      state: MaintenanceTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
    }),
    [scheduleMaintenanceAction.pending.toString()]: (
      state: MaintenanceTypes
    ) => ({
      ...state,
    }),
    [scheduleMaintenanceAction.fulfilled.toString()]: (
      state: MaintenanceTypes,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
        };
      }

      return {
        ...state,
        success,
        message,
        statusCode:status_code
      };
    },
    [scheduleMaintenanceAction.rejected.toString()]: (
      state: MaintenanceTypes,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      success: 0,
    }),
  },
});

export const {
  resetIsMaintenance,
  resetMaintenanceError,
  resetMaintenanceSuccess,
  resetMaintenanceMessage,
  resetStatusCode
} = maintenanceSlice.actions;
